import UploadedMediumCard from './UploadedMediumCard';

export default UploadedMediumCard;
